/** Enhance PatchStitch's existing upload state without replacing its upload request. */
const uploadSelector = '[data-patchstitch-root] .ps-upload__dropzone';
const buttons = new Map();

function isUploading() {
  return Boolean(document.querySelector(`${uploadSelector}.is-busy`));
}

function syncUploads() {
  const busyScopes = new Set();
  for (const zone of document.querySelectorAll(uploadSelector)) {
    const busy = zone.classList.contains('is-busy');
    if (busy) busyScopes.add(zone.closest('.shopify-section') ?? zone.closest('[data-patchstitch-root]'));
    zone.setAttribute('aria-busy', String(busy));
    if (busy && !zone.querySelector('.cp-upload-brand')) {
      const template = document.querySelector('template[data-cp-upload-brand]');
      if (template instanceof HTMLTemplateElement) zone.prepend(template.content.cloneNode(true));
    }
    const hint = zone.querySelector('.ps-upload__hint');
    if (hint) {
      hint.setAttribute('role', 'status');
      hint.setAttribute('aria-live', 'polite');
      const message = typeof Theme !== 'undefined' ? Theme.translations.photo_uploading : 'Uploading your photo… Please keep this page open.';
      if (busy && hint.textContent !== message) hint.textContent = message;
    }
  }
  for (const scope of busyScopes) {
    for (const control of scope.querySelectorAll('button, input:not([type="hidden"]), select, textarea')) {
      if (!buttons.has(control)) buttons.set(control, control.disabled);
      control.disabled = true;
    }
  }
  for (const [button, disabled] of buttons) {
    if (!button.isConnected || ![...busyScopes].some((scope) => scope.contains(button))) {
      button.disabled = disabled;
      buttons.delete(button);
    }
  }
}

// Capture events before the app's handlers, including keyboard-generated clicks and drops.
for (const type of ['click', 'drop', 'change', 'submit']) {
  document.addEventListener(type, (event) => {
    if (!(event.target instanceof Element)) return;
    const scope = event.target.closest('.shopify-section') ?? event.target.closest('[data-patchstitch-root]');
    if (!scope?.querySelector(`${uploadSelector}.is-busy`)) return;
    if (type === 'click' && !event.target.closest('button, input, select, textarea, a, .ps-choice, .ps-upload')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
}

window.addEventListener('beforeunload', (event) => {
  if (!isUploading()) return;
  event.preventDefault();
  event.returnValue = '';
});

// The app replaces its fields after success and when conditional options change.
new MutationObserver((records) => {
  if (records.some((record) => record.type === 'childList' ||
      (record.target instanceof Element && record.target.matches(uploadSelector)))) syncUploads();
}).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
syncUploads();
